import { render } from "./MenuAksi.vue?vue&type=template&id=23318412&scoped=true"
import script from "./MenuAksi.vue?vue&type=script&lang=js"
export * from "./MenuAksi.vue?vue&type=script&lang=js"

import "./MenuAksi.vue?vue&type=style&index=0&id=23318412&scoped=true&lang=css"
import "./MenuAksi.vue?vue&type=style&index=1&id=23318412&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23318412"]])

export default __exports__